import React from 'react';
import ObiLoading from '../common/ObiLoading';

import { ListItemText,
  ListItemIcon,
  ListItem,
  List,
  IconButton,
  Button,
  Hidden,
  Drawer,
  Divider,
  AppBar,
  Toolbar,
  Tooltip,
  Grid,
  Box,
  Icon,
  Typography } from '@mui/material';

import Collapse from '@mui/material/Collapse';

import BusinessIcon from '@mui/icons-material/Business';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import MenuIcon from '@mui/icons-material/Menu';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssessmentIcon from '@mui/icons-material/Assessment';
import NotificationsIcon from '@mui/icons-material/Notifications';
import HelpIcon from '@mui/icons-material/Help';
import LockIcon from '@mui/icons-material/Lock';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import DescriptionIcon from '@mui/icons-material/Description';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PrintIcon from '@mui/icons-material/Print';
import AddIcon from '@mui/icons-material/Add';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import { makeStyles, useTheme } from '@mui/styles';

import { HSAMoneyFormat, groupPlans, familyPlans, noRenewalPlans, onlineOnlyPlans, inArray } from '../../utility/common/GlobalHSA';
import EnvBanner from '../common/EnvBanner';

import { connect } from 'react-redux';
import { withRouter } from "react-router";
import { Link } from 'react-router-dom';

import ObiLogo from '../common/obigraphics/ObiLogo';

import Brightness5Icon from '@mui/icons-material/Brightness5';
import Brightness3Icon from '@mui/icons-material/Brightness3';

import {
  logout,
  generalSwitchTheme
} from '../../actions';
import NotificationListing from '../common/NotificationListing';

const { REACT_APP_VERSION } = process.env;

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  root: {
    
  },
  footer: {
    height: '100px'
  },
  drawer: {
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
    zIndex: 5,
  },
  appBar: {
    zIndex: theme.zIndex.drawer - 1,
    backgroundColor: theme.palette.appBar.main,
    color: theme.palette.appBar.contrastText,
    [theme.breakpoints.up('md')]: {
      paddingLeft: `${drawerWidth}px`
    },
  },
  appProfile:{
    textDecoration: 'none',
    textTransform: 'capitalize',
    userSelect: 'none',
    color: theme.palette.primary.main,
  },
  appTitle:{
    color: theme.palette.appBar.contrastText,
    [theme.breakpoints.up('md')]: {
      paddingLeft: `15px`
    },
  },
  appLogo:{
    textDecoration: 'none',
    padding: theme.spacing(1),
    width: '100px'
  },
  appVersion:{
    padding: theme.spacing(2),
    color: theme.palette.common.white,
    textAlign:'right'
  },
  menuButton: {
    color: theme.palette.primary.main,
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: theme.palette.drawer.main,
    color: theme.palette.drawer.contrastText,
  },
  drawerNotifications: {
    backgroundColor: theme.palette.background.default,
    maxWidth: drawerWidth + 200,
    width: '100%',
    padding: '7px'
  },
  drawerId:{
    padding: theme.spacing(1),
    marginTop: theme.spacing(1),
    borderRadius: '5px',
    backgroundColor: theme.palette.drawerId.main,
    color: theme.palette.drawerId.contrastText
  },
  drawerNavButton:{
    color: theme.palette.drawerNav.contrastText,
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: theme.palette.drawerNav.hover,
    }
  },
  drawerNav:{
    paddingLeft: theme.spacing(2),
    color: theme.palette.drawerNav.contrastText,
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: theme.palette.drawerNav.hover,
    }
  },
  drawerNavClaim: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.success.dark,
    '&:hover': {
      backgroundColor: theme.palette.success.main,
    }
  },
  drawerNavAudit: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.dark,
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    }
  },
  drawerNavIcon:{
    color: theme.palette.drawerNav.contrastText,
  },
  content: {
    flexGrow: 1,
    minHeight: '100vh',
    padding: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      marginLeft: drawerWidth
    },
  },
  nested: {
    paddingLeft: theme.spacing(4),
    color: theme.palette.drawerNav.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.drawerNav.main,
    }
  },
  disablednested:{
    paddingLeft: theme.spacing(4),
    backgroundColor: theme.palette.ltgrey.main,
    '&:hover': {
      backgroundColor: theme.palette.ltgrey.main,
    }
  }
}));

const employeeNav = {
  "personal": {
    name: 'Personal',
    icon: PersonIcon,
    url: undefined,
    external: false,
    willRender: isTerminated,
    innerList: {
      "personalInfo": {
        name: 'Personal Details',
        icon: PersonIcon,
        url: '/employee',
        isDisabled: isNonPlan,
        external: false,
        innerList: null
      },
      "personalPlanDetails": {
        name: 'Plan Details',
        icon: DescriptionIcon,
        url: '/my-plan',
        isDisabled: isNonPlan,
        external: false,
        innerList: null
      },
      "personalBankingDetails": {
        name: 'Banking Details',
        icon: AccountBalanceIcon,
        url: '/banking-details',
        isDisabled: isNonPlan,
        external: false,
        willRender: isTerminated,
        innerList: null
      },
      "notificationPref": {
        name: 'Notifications',
        icon: NotificationsIcon,
        url: '/notifications',
        external: false,
        innerList: null
      },
      "resetPassword": {
        name: 'Reset Password',
        icon: LockIcon,
        url: '/login/reset',
        external: false,
        innerList: {}
      }
    }
  },
  "claimReport": {
    name:'Claim Activity',
    icon: AssessmentIcon,
    url: '/claim-report',
    external: false,
    willRender: allowPersonalClaimActivity,
    innerList: null
  },
  "balanceReport": {
    name:'Balance History',
    icon: AssessmentIcon,
    url: '/balance-report',
    external: false,
    willRender: allowPersonalBalanceActivity,
    innerList: {}
  },
  /*"forms": {
    name: "Forms",
    icon: AssessmentIcon,
    url: undefined,
    external: false,
    innerList: {

    }
  },*/
}

const adminNav = {
  "online":{
    name: "Enable Online Claims",
    icon: AddIcon,
    url: "/business-online-claims",
    external: false,
    willRender: allowOnlineClaimsEnable,
    innerList: null
  },
  "company": {
    name: "Company",
    icon: BusinessIcon,
    url: undefined,
    external: false,
    innerList: {
      "businessContact": {
        name: 'Company Details',
        icon: BusinessIcon,
        url: '/employer',
        external: false,
        willRender: isTerminated,
        innerList: null
      },
      "businessPlanDetails":{
        name: 'Company Plan Details',
        icon: DescriptionIcon,
        url: '/business-plan',
        external: false,
        innerList: null
      },
      "businessCard": {
        name: 'Update Company Credit Card',
        icon: CreditCardIcon,
        url: '/update-card',
        external: false,
        willRender: allowStripeCard,
        innerList: null
      },
      "businessBanking": {
        name: 'Company Banking',
        icon: AccountBalanceIcon,
        url: '/business-banking',
        external: false,
        willRender: isTerminated,
        innerList: null
      },
      "companyFunding": {
        name: 'Company Funding',
        icon: AccountBalanceIcon,
        url: '/company-funding',
        external: false,
        willRender: isTerminated,
        innerList: null
      },
      "insuranceFunding":{
        name: 'Insurance Funding',
        icon: AccountBalanceIcon,
        url: '/insurance-funding',
        willRender: allowInsuranceFunding,
        external: false,
        innerList: null
      },
      "companyReports": {
        name: 'Company Reports',
        icon: AssessmentIcon,
        url: '/company-reports',
        external: false,
        innerList: null
      },
    }
  },
  "employees": {
    name: "Employees",
    icon: GroupIcon,
    url: undefined,
    external: false,
    willRender: isTerminated,
    innerList: {
      "manageEmployees": {
        name: 'Manage Employees',
        icon: GroupIcon,
        url: '/directory/employees',
        external: false,
        innerList: null
      },
      "addEmployees": {
        name: 'Add Employees',
        icon: GroupAddIcon,
        url: '/add-employee',
        external: false,
        willRender: allowEmployeeActions,
        innerList: null
      },
      "manageDivisions": {
        name: 'Manage Divisions',
        icon: GroupIcon,
        url: '/divisions',
        external: false,
        willRender: allowEmployeeActions,
        innerList: null
      },
      "manageClassifications": {
        name:'Manage Classifications',
        icon: GroupIcon,
        url: '/classifications',
        external: false,
        willRender: allowEmployeeActions,
        innerList: null
      },
    }
  },
  /*"addons":{
    name: "Addons",
    icon: AddIcon,
    url: undefined,
    external: false,
    willRender: allowAddons,
    innerList: {*/
      "wellness": {
        name: "Wellness Setup",
        icon: BusinessIcon,
        url: '/wellness/setup',
        external: false,
        willRender: allowWellnessSetup,
        innerList: null
      },
      "wellnessManage": {
        name: "Wellness Manage",
        icon: BusinessIcon,
        url: '/wellness/manage',
        external: false,
        willRender: allowWellnessManage,
        innerList: null
      },
  /*}
  } */
}

const generalNav = {
  "documents": {
    name:'Documents',
    icon: DescriptionIcon,
    url: '/documents',
    external: false,
    innerList: null
  },
  "privacy": {
    name: "Privacy Policy",
    icon: DescriptionIcon,
    url: "https://www.olympiafinancial.com/privacy-policy",
    external: true,
    innerList: null
  },
  "resources": {
    name: "Resource Library",
    icon: MenuBookIcon,
    url: "https://www.olympiabenefits.com/knowledge-base",
    external: true,
    innerList: null
  }
};

function allowWellnessSetup(props){
  const isTerminated = (props.user.TERMINATED_FLAG && props.user.TERMINATED_FLAG == 'Y');
  if(isTerminated) return !isTerminated;
  const isCustomGroup = (props.user.CUSTOMIZED_BENEFITS === 'Y');
  if(isCustomGroup) return false;
  const contract_number = parseInt(props.user.CONTRACT_TYPE);
  const isGroupPlan = groupPlans.includes(contract_number);
  return (isGroupPlan && !props.company.HAS_WELLNESS);
}
function allowWellnessManage(props){
  const isTerminated = (props.user.TERMINATED_FLAG && props.user.TERMINATED_FLAG == 'Y');
  if(isTerminated) return !isTerminated;
  const isCustomGroup = (props.user.CUSTOMIZED_BENEFITS === 'Y');
  if(isCustomGroup) return false;
  const contract_number = parseInt(props.user.CONTRACT_TYPE);
  const isGroupPlan = groupPlans.includes(contract_number);
  const onlineClaimOk = (props.company.ONLINE_CLAIM_OK === 'Y');

  return (isGroupPlan && props.company.HAS_WELLNESS && onlineClaimOk);
}

function allowEmployeeActions(props){
  const isTerminated = (props.user.TERMINATED_FLAG && props.user.TERMINATED_FLAG == 'Y');
  if(isTerminated) return !isTerminated;
  const contract_number = parseInt(props.user.CONTRACT_TYPE);
  const isGroupPlan = groupPlans.includes(contract_number);
  return isGroupPlan
}

function allowOnlineClaimsEnable(props){
  const isTerminated = (props.user.TERMINATED_FLAG && props.user.TERMINATED_FLAG == 'Y');
  if(isTerminated) return false;
  const isCustomGroup = (props.user.CUSTOMIZED_BENEFITS === 'Y');
  if(isCustomGroup) return false;
  const isPaperPlan = !(inArray(onlineOnlyPlans, parseInt(props.user.PLAN_TYPE)));
  const onlineClaimOk = (props.user.ONLINE_CLAIM_OK === 'Y');
  return isPaperPlan && !onlineClaimOk;
}

function allowStripeCard(props){
  const isTerminated = (props.user.TERMINATED_FLAG && props.user.TERMINATED_FLAG == 'Y');
  if(isTerminated) return !isTerminated;
  const contract_number = parseInt(props.user.CONTRACT_TYPE);
  const isGroupPlan = groupPlans.includes(contract_number);
  const isRenewalPlan = !noRenewalPlans.includes(contract_number);
  return !isGroupPlan && isRenewalPlan; // if just isRenewal then it would miss 13 which is a banking details only renewal
}

function allowMakeClaim(props){
  const isCustomGroup = (props.user.CUSTOMIZED_BENEFITS === 'Y');
  if(isCustomGroup) return false;
  const isNonPlan = (props.user.NON_MEMBER_ADMIN_ONLY === 'Y');
  const onlineClaimOk = (props.user.ONLINE_CLAIM_OK === 'Y');
  return !isNonPlan && onlineClaimOk;
}

function allowPrintForm(props){
  const isNonPlan = (props.user.NON_MEMBER_ADMIN_ONLY === 'Y');
  if(isNonPlan) return !isNonPlan;
  const onlineClaimOnly = (props.user.ONLINE_CLAIMS_ONLY === 'Y');
  if(onlineClaimOnly) return !onlineClaimOnly;
  const isOnlineOnlyPlan = (inArray(onlineOnlyPlans, parseInt(props.user.PLAN_TYPE)));
  if(isOnlineOnlyPlan) return !isOnlineOnlyPlan;
  return true;
}

function allowPersonalClaimActivity(props){
  const isNonPlan = (props.user.NON_MEMBER_ADMIN_ONLY === 'Y');
  return !isNonPlan;
}

function allowPersonalBalanceActivity(props){
  const isCustomGroup = (props.user.CUSTOMIZED_BENEFITS === 'Y');
  const isNonPlan = (props.user.NON_MEMBER_ADMIN_ONLY === 'Y');
  return !isNonPlan && !isCustomGroup;
}

function isNonPlan(props){
  const isNonPlan = (props.user.NON_MEMBER_ADMIN_ONLY === 'Y');
  return isNonPlan;
}

function isTerminated(props){
  const isTerminated = (props.user.TERMINATED_FLAG && props.user.TERMINATED_FLAG == 'Y');
  return !isTerminated;
}

/*function allowAddons(props){
  const contract_number = parseInt(props.user.CONTRACT_TYPE);
  const isGroupPlan = groupPlans.includes(contract_number);
  return isGroupPlan
}*/

function allowInsuranceFunding(props){
  const isTerminated = (props.user.TERMINATED_FLAG && props.user.TERMINATED_FLAG == 'Y');
  if(isTerminated) return !isTerminated;
  const plan_number = parseInt(props.user.PLAN_TYPE);
  const planInsuranceIncluded = familyPlans.includes(plan_number);
  const planInsured = (props.user.TRAVEL_INS !== "NONE"
    || props.user.CAT_DRUG !== 'N'
    || props.user.EEI_INS !== 'N'
    || props.user.EE_HAS_EEI === 1
    || props.user.EEI_GS !== 'N' );
  return !planInsuranceIncluded && planInsured;
}

function showAnnualLimit(props){
  return (props.user.CUSTOMIZED_BENEFITS != 'Y' || props.user.LIMIT_TYPE == 'STANDARD');
}

function showWellnessLimit(props){
  return (props.user.WELLNESS == 'Y');
}

function customGroup(props){
  const isCustomGroup = (props.user.CUSTOMIZED_BENEFITS === 'Y');
  return isCustomGroup;
}

function updateTheme(props){
  props.generalSwitchTheme();
}

function renderNavElement(navElement, props, classEle, classIcon, endIcon){
  if(navElement.willRender && !navElement.willRender(props)){
    return false;
  }

  let disabled = false;
  if(navElement.isDisabled){
    if(typeof navElement.isDisabled == 'function'){
      disabled = navElement.isDisabled(props);
    }else{
      disabled = (navElement.isDisabled);
    }
  }

  return <ListItem key={navElement.name} 
    className={classEle}
    button
    {...(navElement.external && navElement.url)? {href: navElement.url, component: Button, target: '_blank', rel: "noreferrer"}: {}}
    {...(!navElement.external && navElement.url)? {to: navElement.url, component: Link}: {}}  
    {...(disabled)? {disabled: disabled}: {}}
    {...(navElement.onClick)? {onClick: navElement.onClick}: {}}
     >
    <ListItemIcon><Icon className={classIcon} component={navElement.icon} /></ListItemIcon>
    <ListItemText primary={navElement.name} />
    {endIcon}
  </ListItem>
}

function renderList(navElement, props, classes, handleMenuExpand, expanded, renderFlat=false){
  if(!navElement){
    return false;
  }
  if(!navElement.innerList || Object.values(navElement.innerList).length < 1){
    return renderNavElement(navElement, props, classes.drawerNav, classes.drawerNavIcon);
  }
  if(renderFlat){
    return Object.values(navElement.innerList).map((innerNavElement) => {
        return renderNavElement(innerNavElement, props, classes.drawerNav, classes.drawerNavIcon);
      });
  }
  return (
    <div>
      <ListItem key={navElement.name} className={classes.drawerNav} button onClick={() => handleMenuExpand(navElement.name)}>
        <ListItemIcon><Icon className={classes.drawerNavIcon} component={navElement.icon} /></ListItemIcon>
        <ListItemText primary={navElement.name} />
        {expanded[navElement.name] ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={expanded[navElement.name]} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {Object.values(navElement.innerList).map((innerNavElement) => {
            return renderNavElement(innerNavElement, props, classes.nested, classes.drawerNavIcon);
          })}
        </List>
      </Collapse>
    </div>
  );
}

function WrapperMain(props) {
  
  const { window } = props;
  const { usePrint, printPreview } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [notificationsOpen, setNotificaionsOpen] = React.useState(false);
  const [expanded, setExpanded] = React.useState(false);

  const isAdmin = (props.user.GROUP_ADMIN === 'Y');
  const isNonPlan = (props.user.NON_MEMBER_ADMIN_ONLY === 'Y');
  const isInAudit = (props.user.EMPLOYEE_AUDIT_STATE > 0);

  if(usePrint && printPreview){
    return printPreview;
  }

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMenuExpand = (id) => {
    setExpanded((prevState => ({...prevState, [id]: !prevState[id]})));
  }

  const drawer = (
    <div>
      <Grid container justifyContent="flex-start" alignItems="center" >
        <Grid item xs={12}>
          <Box p={2}>
            <Grid container justifyContent="center" alignItems="center">
              <Grid item xs={6}>
                <ObiLogo width="100%" fill={theme.palette.drawerLogo.main}/>
              </Grid>
            </Grid>
            <Grid container justifyContent="space-between" spacing={2} alignItems="center">
              <Grid item xs={6}>
                <Grid container justifyContent="space-between" alignItems="center" className={classes.drawerId}>
                  <PersonIcon />
                  <Typography>{props.user.ID}</Typography>
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Grid container justifyContent="space-between" alignItems="center" className={classes.drawerId}>
                  <GroupIcon />
                  <Typography>{props.user.EMPLOYER}</Typography>
                </Grid>
              </Grid>
            </Grid>
            {showAnnualLimit(props) &&
              <Grid container justifyContent="space-between" alignItems="center" className={classes.drawerId}>
                <Typography>HSA Balance</Typography>
                <Typography>{HSAMoneyFormat(props.user.BALANCE)}</Typography>
              </Grid>
            }
            {showWellnessLimit(props) &&
              <Grid container justifyContent="space-between" alignItems="center" className={classes.drawerId}>
                <Typography>WSA Balance</Typography>
                <Typography>{HSAMoneyFormat(props.user.WELLNESS_BALANCE)}</Typography>
              </Grid>
            }
            {isAdmin &&
              <Grid container justifyContent="space-between" alignItems="center" className={classes.drawerId}>
                <Typography>Group Balance</Typography>
                <Typography>{HSAMoneyFormat(props.user.GROUP_BALANCE)}</Typography>
              </Grid>
            }
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Divider />
          <List>
            <ListItem key={'Dashboard'} className={classes.drawerNav} component={Link} button to={'/'}>
                <ListItemIcon><Icon className={classes.drawerNavIcon} component={DashboardIcon} /></ListItemIcon>
                <ListItemText primary={'Dashboard'} />
            </ListItem>
            {allowMakeClaim(props) &&
              <ListItem key={(isInAudit)? 'Claim Audit in Process' : 'Make a Claim'} className={(isInAudit)? classes.drawerNavAudit : classes.drawerNavClaim} component={Link} button to={'/claims'} disabled={isInAudit}>
                  <ListItemIcon><Icon className={classes.drawerNavIcon} component={LocalHospitalIcon} /></ListItemIcon>
                  <ListItemText primary={(isInAudit)? 'Claim Audit in Process' : 'Make a Claim'} />
              </ListItem>
            }
            {allowPrintForm(props) &&
              <ListItem key={'Print Claim Form'} className={classes.drawerNavClaim} component={Link} button to={'/claim-form-print'} disabled={isInAudit}>
                  <ListItemIcon><Icon className={classes.drawerNavIcon} component={PrintIcon} /></ListItemIcon>
                  <ListItemText primary={'Print Claim Form'} />
              </ListItem>
            }
            {customGroup(props) &&
              <ListItem key={'View Benefit Summary'} className={classes.drawerNav} component={Link} button to={'/summary-of-benefits'}>
                  <ListItemIcon><Icon className={classes.drawerNavIcon} component={AssessmentIcon} /></ListItemIcon>
                  <ListItemText primary={'View Benefit Summary'} />
              </ListItem>
            }
            {Object.values(employeeNav).map( (employeeElement) => {
              return renderList(employeeElement, props, classes, handleMenuExpand, expanded, !(isAdmin || isNonPlan));
            })}

          </List>
          <Divider />
          {(isAdmin || isNonPlan) && 
            <List>
              {Object.values(adminNav).map( (adminElement) => {
                return renderList(adminElement, props, classes, handleMenuExpand, expanded, false);
              })}
            </List>}
          <Divider />
          <List>
            {Object.values(generalNav).map( (genElement) => {
              return renderList(genElement, props, classes, handleMenuExpand, expanded, false);
            })}
            <ListItem key={'Logout'} className={classes.drawerNav} button onClick={ () => props.logout(props.user.TYPE) }>
              <ListItemIcon><ExitToAppIcon className={classes.drawerNavIcon} /></ListItemIcon>
              <ListItemText primary={'Logout'} />
            </ListItem>
          </List>
          <Divider />
          <List>
            <ListItem key={'Theme'} className={classes.drawerNav} button onClick={()=>updateTheme(props)} >
              <ListItemIcon><Icon className={classes.drawerNavIcon} component={(props.chosenTheme == 'dark')? Brightness5Icon: Brightness3Icon} /></ListItemIcon>
              <ListItemText primary={(props.chosenTheme == 'dark')? 'Enable Light Mode': 'Enable Dark Mode'} />
            </ListItem>
          </List>

          <Typography className={classes.appVersion} variant="caption" display="block" align="right">app v{REACT_APP_VERSION}<br/>Copyright © {new Date().getFullYear()} Olympia Benefits Inc.<br/>All Rights Reserved</Typography>
        </Grid>
      </Grid>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <div className={classes.root}>
      <AppBar position="sticky" className={classes.appBar}>
        <EnvBanner />
        <Toolbar>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item xs>
            <Hidden mdUp>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                className={classes.menuButton}
              >
                <MenuIcon />
              </IconButton>
            </Hidden>
            <Hidden mdDown>
              <Grid item xs zeroMinWidth>
                <Typography className={classes.appTitle} noWrap>{props.title}</Typography>
              </Grid>
            </Hidden>
          </Grid>

          <Hidden mdUp>
            <Grid item className={classes.appLogo} component={Link} to="/">
              <Grid container direction='row' justifyContent="center" alignItems="center">
                <Grid item >
                  <ObiLogo height={50} fill={theme.palette.primary.main}/>
                </Grid>
              </Grid>
            </Grid>
          </Hidden>

          <Grid item xs>
            <Grid container direction='row' justifyContent="flex-end" alignItems="center">
              <Grid item >
                <Tooltip title="Notifications" arrow aria-label="Notifications">
                  <IconButton className={classes.appProfile} onClick={() => setNotificaionsOpen(!notificationsOpen)}>
                    <NotificationsIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
              <Grid item>
                <Hidden lgUp>
                  <Tooltip title="Personal Details" arrow aria-label="Personal Details">
                    <IconButton
                      component={Link} 
                      to="/employee"
                      className={classes.menuButton}>
                      <PersonIcon />
                    </IconButton>
                    </Tooltip>  
                </Hidden>
                <Hidden lgDown>
                  <Tooltip title="Personal Details" arrow aria-label="Personal Details">
                    <Button className={classes.appProfile} component={Link} to="/employee">
                      <PersonIcon />
                      <Typography>{props.user.FIRST_NAME + " " + props.user.LAST_NAME}</Typography>
                    </Button>
                  </Tooltip>
                </Hidden>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer} aria-label="side navigation">
        <Hidden lgUp implementation="js">
          <Drawer
            container={container}
            variant="temporary"
            anchor={'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden mdDown implementation="js">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>

      <Drawer
        container={container}
        variant="temporary"
        anchor={'right'}
        open={notificationsOpen}
        onClose={() => setNotificaionsOpen(false)}
        classes={{
          paper: classes.drawerNotifications,
        }}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
      >
        <div>
          <Box p={2}>
            <NotificationListing backAction={() => setNotificaionsOpen(false)} type="EMPLOYEE"/>
          </Box>
        </div>
      </Drawer>
      <main className={classes.content}>
          {(props.inSuspense)? <ObiLoading /> : props.children}
        <div className={classes.footer} />
      </main>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    company: state.employer.employer,
    error: state.auth.error,
    errors: state.auth.errors,
    loading: state.auth.loading,
    chosenTheme: state.general.chosenTheme
  };
};

export default connect(mapStateToProps, {
  logout,
  generalSwitchTheme
})(withRouter(WrapperMain));
